import { useLoginOrSignupPageData } from '#src/app/pages/loginOrSignup/pageContext';
import { useLoginSocialButtons } from '#src/app/pages/loginOrSignup/shared/hooks';
import { useTrackExperimentExposureOnMount } from '#src/app/shared/hooks/tracking';

type Result = ModelHookResult<{
	showSocialButtons: boolean;
	socialButtonsFirst: boolean;
}>;

export function useEmailStep(): Result {
	const {
		data: { buttons },
	} = useLoginSocialButtons();
	const { data: pageData } = useLoginOrSignupPageData();

	const experiment = pageData.experiments.loginSocialButtonsFirstExperiment;
	useTrackExperimentExposureOnMount(experiment);

	return {
		data: {
			showSocialButtons: !!buttons.length,
			socialButtonsFirst: experiment.variation === 'variant',
		},
	};
}
